export default {
  welcomeDialog: {
    logoAlt: 'Logo Aptelecare',
    welcome: {
      introduction: {
        firstParagraph: {
          welcome: 'Bienvenue sur l\'application',
          description: ', ton alliée pour t’entraîner et maximiser ton potentiel, conçue pour tous les sportifs, débutants ou experts ! '
        },
        secondParagraph: {
          noMoralizingSpeech: 'Ici, pas de discours moralisateur, juste',
          practicalAdvices: 'des conseils pratiques et inspirants, dans un parcours dynamique et sécurisé',
          capableOfBoosting: ', capable de booster tes',
          performance: 'performances',
          andYour: 'et ta',
          recovery: 'récupération',
          whileTakingCareOf: 'en prenant soin de ta',
          mentalHealth: 'santé mentale',
          andYour2: 'et de ton',
          wellBeing: 'bien-être.'
        },
        thirdParagraph: {
          theIdea: 'L\'idée ?',
          toAssistYou: 'T\'accompagner pas à pas pour que chaque jour compte dans ta progression.'
        }
      },
      description: {
        withThisApplication: 'Avec cette appli,',
        youHaveEverything: 'tu as tout ce qu\'il faut pour suivre tes avancées, comprendre ton corps et ton mental, et donner le meilleur de toi-même :',
        selfEvaluationForm: 'Des questionnaires simples, rapides et efficaces pour auto-évaluer ton état de forme au quotidien.',
        physicalAndCognitiveExercises: 'Des exercices physiques et cognitifs, validés scientifiquement, pour renforcer ton corps et ton cerveau, pensés pour booster ta récupération et améliorer tes performances.',
        balanceTests: 'Des tests d’équilibre avec analyse vidéo, pour découvrir tes points forts et ceux à renforcer, te guider précisément et entrainer ta stabilité et tes réflexes.',
        breathingExercises: 'Des exercices de respiration spécialement conçus pour apaiser ton mental, réguler ton stress et booster ton bien-être.',
        tipsAndRoutines: 'Des astuces et routines pour améliorer la qualité de ton sommeil et optimiser ta récupération.',
        nutritionRecommendation: 'Des recommandations alimentaires pour apporter tous les nutriments nécessaire à ton activité.'
      },
      recap: {
        whatYouWillLike: 'Ce que tu vas aimer',
        aCustomSupport: 'Un accompagnement sur-mesure, validé par des experts, qui te guide étape par étape pour une meilleure expérience, pour évoluer à ton rythme et sans pression, et suivre ta progression jour après jour, pour que chaque séance te soit réellement bénéfique.',
        keyToSuccess: 'La clé du succès ? La régularité.',
        beRegular: 'En t’engageant chaque jour, à ton rythme, tu prends ta santé en main, tu favorises une récupération efficace, tu optimises ta performance et tu cultives une santé mentale solide. Faire ces exercices régulièrement, c’est le secret pour devenir plus fort, plus rapide, plus concentré.',
        readyToSurpassYourself: 'Alors, prêt à te surpasser ?'
      },
      conclusion: {
        withTheApplication: 'Avec l\'application {appName}',
        completeAndCustomProgram: ', tu bénéficies d’un programme complet et personnalisé.',
        changeYourEffortsIntoSuccess: 'Transformes tes efforts en succès, pour être confiant et prêt à relever tous les défis !'
      }
    },
    startButton: 'Commencer'
  },
  concussionHistory: {
    logoAlt: 'Logo France Rugby',
    title: 'Historique des Commotions',
    instructions: {
      description1: 'Ce questionnaire permet de recueillir des informations sur vos antécédents de commotions cérébrales.',
      description2: 'Ces informations aideront à personnaliser votre suivi médical.',
      startButton: 'Commencer'
    },
    form: {
      previousConcussions: {
        title: 'Antécédents de commotions',
        toggle: 'J\'ai déjà subi une ou plusieurs commotions cérébrales'
      },
      concussionDetails: {
        title: 'Commotion',
        date: 'Date approximative (mois/année)',
        circumstances: 'Circonstances (match, entraînement, autre)',
        symptoms: 'Principaux symptômes ressentis',
        duration: 'Durée des symptômes (jours)',
        medicalConsultation: 'J\'ai consulté un médecin pour cette commotion',
        treatment: 'Traitement ou suivi médical reçu'
      },
      addConcussion: 'Ajouter une commotion',
      additionalInfo: {
        title: 'Informations complémentaires',
        label: 'Autres informations pertinentes concernant vos antécédents'
      },
      submitButton: 'Soumettre'
    },
    confirmation: {
      title: 'Questionnaire soumis',
      thankYou: 'Merci d\'avoir complété le questionnaire sur votre historique de commotions cérébrales.',
      recordedHistory: 'Antécédents enregistrés : {count} commotion(s)',
      medicalTeamInfo: 'Ces informations seront utilisées par l\'équipe médicale pour personnaliser votre suivi.',
      backButton: 'Retour'
    }
  },
  concussionSymptoms: {
    logoAlt: 'Logo France Rugby',
    title: 'Auto-évaluation des Symptômes',
    instructions: {
      description1: 'Ce questionnaire fait partie du protocole officiel FFR (inspiré du SCAT5) et doit être rempli quotidiennement, jusqu\'à votre reprise complète.',
      description2: 'Pour chaque symptôme, veuillez indiquer :',
      presence: 'Sa présence ou absence',
      severity: 'Son niveau de sévérité (sur une échelle de 0 à 6)',
      startButton: 'Commencer'
    },
    form: {
      severityLegend: 'Sévérité: 0 (aucune) à 6 (sévère)',
      categories: {
        physical: 'Symptômes physiques',
        cognitive: 'Symptômes cognitifs',
        emotional: 'Symptômes émotionnels',
        sleep: 'Symptômes liés au sommeil'
      },
      severity: 'Sévérité',
      submitButton: 'Soumettre'
    },
    confirmation: {
      title: 'Questionnaire soumis',
      thankYou: 'Merci d\'avoir complété le questionnaire d\'auto-évaluation des symptômes.',
      backButton: 'Retour'
    }
  },
  progressiveReturnFollowUp: {
    logoAlt: 'Logo France Rugby',
    title: 'Programme de Reprise Du Jeu (RPDJ)',
    instructions: {
      description1: 'Ce questionnaire fait partie du protocole officiel FFR pour la reprise progressive du jeu après une commotion cérébrale.',
      description2: 'Vous devez compléter ce questionnaire après chaque palier de reprise pour valider l\'absence de symptômes avant de passer au palier suivant.',
      startButton: 'Commencer'
    },
    form: {
      stageTitle: 'Questionnaire de Palier {stage}',
      currentStage: {
        title: 'Palier actuel',
        selectLabel: 'Sélectionnez votre palier actuel'
      },
      plannedActivity: {
        title: 'Activité planifiée',
        label: 'Décrivez l\'activité réalisée pendant ce palier'
      },
      activityCompletion: {
        title: 'Réalisation de l\'activité',
        toggle: 'J\'ai complété l\'activité planifiée'
      },
      symptomsAppearance: {
        title: 'Apparition de symptômes',
        toggle: 'Des symptômes sont apparus pendant ou après l\'activité',
        warning: 'Attention : La présence de symptômes nécessite un retour au palier précédent. Consultez votre médecin.',
        specifySymptoms: 'Veuillez préciser les symptômes apparus :'
      },
      severityLegend: 'Sévérité: 0 (aucune) à 6 (sévère)',
      categories: {
        physical: 'Symptômes physiques',
        cognitive: 'Symptômes cognitifs',
        emotional: 'Symptômes émotionnels',
        sleep: 'Symptômes liés au sommeil'
      },
      comments: {
        title: 'Commentaires',
        label: 'Commentaires additionnels'
      },
      submitButton: 'Soumettre'
    },
    confirmation: {
      title: 'Questionnaire soumis',
      stageTitle: 'Programme de Reprise Du Jeu - Palier {stage}',
      thankYou: 'Merci d\'avoir complété le questionnaire de suivi pour le palier {stage}.',
      symptomsWarning: 'Attention : Des symptômes sont apparus. Vous devez revenir au palier précédent et consulter votre médecin.',
      congratulations: 'Félicitations : Vous avez complété ce palier sans symptômes. Vous pouvez passer au palier suivant après 24h.',
      activityNotCompleted: 'Activité non complétée : Essayez de compléter l\'activité avant de passer au palier suivant.',
      nextStage: 'Prochain palier : {description}',
      backButton: 'Retour'
    },
    stages: {
      options: {
        1: 'Palier 1: Repos complet',
        2: 'Palier 2: Activité légère',
        3: 'Palier 3: Exercices spécifiques au rugby',
        4: 'Palier 4: Entraînement sans contact',
        5: 'Palier 5: Entraînement avec contact',
        6: 'Palier 6: Retour au jeu'
      },
      descriptions: {
        1: 'Repos physique et cognitif complet jusqu\'à disparition des symptômes.',
        2: 'Activités aérobiques légères comme la marche ou le vélo stationnaire à faible intensité.',
        3: 'Exercices spécifiques au rugby sans risque d\'impact à la tête.',
        4: 'Exercices d\'entraînement plus complexes sans contact.',
        5: 'Après autorisation médicale, reprise des activités normales d\'entraînement avec contact.',
        6: 'Retour au jeu normal après autorisation médicale.'
      },
      stage7: 'Palier 7: Retour au jeu - Après autorisation médicale.'
    }
  },
  symptoms: {
    // Physical symptoms
    headache: 'Maux de tête',
    nausea: 'Nausées',
    vomiting: 'Vomissements',
    dizziness: 'Étourdissements / Sensation de vertige',
    visionProblems: 'Troubles visuels (vision floue, double)',
    lightSensitivity: 'Sensibilité à la lumière',
    noiseSensitivity: 'Sensibilité au bruit',
    balanceProblems: 'Troubles de l\'équilibre',
    fatigue: 'Fatigue physique',
    slowness: 'Sensation de ralentissement',
    // Cognitive symptoms
    mentalConfusion: 'Confusion / Désorientation',
    memoryProblems: 'Troubles de la mémoire',
    concentrationDifficulties: 'Difficulté de concentration',
    mentalSlowness: 'Sentiment de "lenteur mentale"',
    // Emotional symptoms
    irritability: 'Irritabilité',
    sadness: 'Tristesse ou humeur dépressive',
    anxiety: 'Anxiété / Nervosité',
    moodSwings: 'Sautes d\'humeur',
    // Sleep symptoms
    sleepProblems: 'Troubles d\'endormissement',
    excessiveSleepiness: 'Somnolence excessive',
    poorSleepQuality: 'Réveils fréquents / Mauvaise qualité du sommeil'
  },
  exercises: {
    sections: {
      videoExercises: 'Mes exercices vidéos',
      exercises: 'Mes exercices',
      breathing: 'Ma respiration',
      questionnaires: 'Mes questionnaires'
    },
    tests: {
      dsst: {
        name: 'Test DSST',
        description: 'Vitesse de traitement et attention soutenue',
        instructions: {
          title: 'Instructions pour le test DSST',
          description1: 'Ce test mesure votre vitesse de traitement et votre attention soutenue.',
          description2: 'Vous verrez une série de chiffres, un à la fois. Pour chaque chiffre, vous devez sélectionner le symbole correspondant selon la légende affichée en haut de l\'écran.',
          description3: 'Essayez de répondre aussi rapidement et précisément que possible.',
          description4: 'Le test dure {count} secondes.',
          startButton: 'Commencer le test'
        },
        running: {
          timeRemaining: 'Temps restant:',
          question: 'Question:'
        },
        results: {
          title: 'Résultats du test DSST',
          score: 'Score',
          accuracy: 'Précision',
          averageResponseTime: 'Temps de réponse moyen',
          correctAnswers: 'Réponses correctes',
          retryButton: 'Refaire le test'
        }
      },
      srt: {
        name: 'Test SRT',
        description: 'Evaluation du temps de réaction',
        instructions: {
          title: 'Instructions pour le test SRT',
          description1: 'Ce test mesure votre temps de réaction simple.',
          description2: 'Un stimulus visuel (une forme) apparaîtra à l\'écran. Cliquez aussi rapidement que possible dès que vous voyez le stimulus.',
          description3: 'Votre temps de réaction sera mesuré en millisecondes.',
          description4: 'Le test comprend {count} essais.',
          startButton: 'Commencer le test'
        },
        running: {
          trial: 'Essai: {current} / {total}',
          remaining: 'Restant: {count}',
          waiting: 'Attendez l\'apparition du stimulus...',
          lastTime: 'Dernier temps: {time}'
        },
        results: {
          title: 'Résultats du test SRT',
          score: 'Score (moyenne des 10 meilleures)',
          avgReactionTime: 'Temps de réaction moyen',
          fastestTime: 'Temps le plus rapide',
          validTrials: 'Essais valides',
          retryButton: 'Refaire le test'
        }
      },
      goNoGo: {
        name: 'Test Go/No-Go',
        description: 'Inhibition comportementale et attention soutenue',
        instructions: {
          title: 'Instructions pour le test Go/No-Go',
          description1: 'Ce test mesure votre capacité d\'inhibition comportementale, votre attention soutenue et votre rapidité de traitement.',
          description2: 'Vous verrez apparaître à l\'écran deux types de stimuli :',
          goStimulus: 'Stimulus "Go" (cercle vert) : Cliquez aussi rapidement que possible.',
          noGoStimulus: 'Stimulus "No-Go" (croix rouge) : Ne cliquez PAS, inhibez votre réponse.',
          description3: 'Chaque stimulus apparaîtra pendant une courte durée. Essayez d\'être aussi rapide et précis que possible.',
          startButton: 'Commencer le test'
        },
        running: {
          trial: 'Essai: {current} / {total}',
          remaining: 'Restant: {count}',
          waiting: 'Attendez l\'apparition du stimulus...',
          missedGo: 'Manqué! (Go)',
          correctNoGo: 'Correct! (No-Go)',
          correctGo: 'Correct! (Go) - {time}',
          incorrectNoGo: 'Incorrect! (No-Go)'
        },
        results: {
          title: 'Résultats du test Go/No-Go',
          avgReactionTime: 'Temps de réaction moyen (Go)',
          inhibitionRate: 'Taux d\'inhibition',
          commissionErrors: 'Erreurs de commission (No-Go)',
          omissionErrors: 'Erreurs d\'omission (Go)',
          retryButton: 'Refaire le test'
        }
      },
      stroop: {
        name: 'Test Stroop',
        description: 'Inhibition cognitive et attention sélective',
        instructions: {
          title: 'Instructions pour le test Stroop',
          description1: 'Ce test mesure votre capacité d\'inhibition cognitive et votre attention sélective.',
          description2: 'Vous verrez des mots de couleurs (ex: "ROUGE", "VERT") affichés dans différentes couleurs.',
          description3: 'Votre tâche est de sélectionner la couleur dans laquelle le mot est écrit, et non pas ce que le mot dit.',
          description4: 'Par exemple, si vous voyez le mot "ROUGE" écrit en couleur verte, vous devez sélectionner "VERT".',
          description5: 'Essayez de répondre aussi rapidement et précisément que possible.',
          startButton: 'Commencer le test'
        },
        colorVision: {
          title: 'Test de vision des couleurs',
          description: 'Veuillez choisir la palette de couleurs qui vous convient le mieux :',
          palettes: {
            standard: {
              name: 'Standard',
              description: 'Pour vision normale'
            },
            protanopia: {
              name: 'Protanopie',
              description: 'Déficience de vision du rouge'
            },
            tritanopia: {
              name: 'Tritanopie',
              description: 'Déficience de vision du bleu'
            },
            deuteranopia: {
              name: 'Deutéranopie',
              description: 'Déficience de vision du vert'
            }
          }
        },
        verification: {
          title: 'Vérification de la vision des couleurs',
          question: 'Quelle est la couleur affichée ci-dessous ?'
        },
        running: {
          trial: 'Essai:',
          remaining: 'Restant:',
          waitingMessage: 'Attendez l\'apparition du mot...'
        },
        feedback: {
          timeout: 'Temps écoulé!',
          correct: 'Correct!',
          incorrect: 'Incorrect! La couleur correcte était'
        },
        results: {
          title: 'Résultats du test Stroop',
          congruentReactionTime: 'Temps de réaction (congruent)',
          incongruentReactionTime: 'Temps de réaction (incongruent)',
          stroopEffect: 'Effet Stroop',
          errorRate: 'Taux d\'erreurs',
          inhibitionRate: 'Taux d\'inhibition',
          retryButton: 'Refaire le test'
        },
        colors: {
          rouge: 'Rouge',
          vert: 'Vert',
          bleu: 'Bleu',
          jaune: 'Jaune',
          violet: 'Violet',
          orange: 'Orange',
          rose: 'Rose'
        }
      },
      trailMaking: {
        name: 'Trail Making Test',
        description: 'Flexibilité cognitive et vitesse de traitement',
        instructions: {
          title: 'Instructions pour le Trail Making Test',
          description1: 'Ce test mesure votre flexibilité cognitive et votre vitesse de traitement.',
          partA: 'Partie A : reliez de 1 à 25 dans l\'ordre.',
          partB: 'Partie B : reliez en alternance chiffres (1→2…) et lettres (A→B…) : 1→A→2→B… jusqu\'à 13.',
          drawing: 'Appuyez sur le premier point et, sans lever le doigt, tracez une ligne continue en passant par chaque point dans l\'ordre. La trajectoire s\'affichera.',
          startButton: 'Commencer le test'
        },
        running: {
          partTitle: 'Trail Making Test – Partie'
        },
        partB: {
          completedA: 'Vous avez terminé la partie A',
          description1: 'La Partie B va maintenant commencer.',
          description2: 'Cette fois, vous devrez alterner entre chiffres et lettres :',
          description3: '1 → A → 2 → B → ...',
          startButton: 'Commencer la Partie B'
        },
        results: {
          title: 'Résultats du Trail Making Test',
          timeA: 'Temps partie A',
          timeB: 'Temps partie B',
          mistakesA: 'Erreurs partie A',
          mistakesB: 'Erreurs partie B',
          retryButton: 'Refaire le test'
        }
      },
      nBack: {
        name: 'Test N-Back',
        description: 'Évaluation de la mémoire de travail',
        instructions: {
          title: 'Instructions pour le test N-Back',
          description1: 'Ce test évalue votre mémoire de travail et votre concentration.',
          description2: 'Trois niveaux vous seront proposés : 1-back, 2-back et 3-back. À chaque niveau, une série de chiffres vous seront présentés un à un.',
          description3: 'Votre tâche est d\'indiquer si le chiffre actuel est identique à celui présenté n positions en arrière (n dépend du niveau : 1, 2 ou 3).',
          description4: 'Appuyez sur Identique si vous pensez que c\'est le cas, sinon sur différent.',
          description5: 'Le test comporte {count} chiffres par niveau. Essayez de répondre aussi rapidement et précisément que possible.',
          startLevel: 'Niveau de départ',
          level1: '1-back',
          level2: '2-back',
          level3: '3-back',
          startButton: 'Commencer le test'
        },
        running: {
          level: 'Niveau {n}-Back',
          identical: 'IDENTIQUE',
          different: 'DIFFÉRENT',
          memorize: 'Retenez l\'ordre des chiffres qui apparaissent à l\'écran',
          next: 'Suivant'
        },
        results: {
          levelTitle: 'Résultats du niveau {n}-Back',
          precision: 'Précision',
          avgTime: 'Temps moyen',
          nextLevel: 'Passer au {n}-Back',
          endTest: 'Terminer le test',
          finalTitle: 'Résultats du test N-Back',
          avgReactionTime: 'Temps de réaction moyen',
          validTrials: 'Essais valides',
          retryButton: 'Refaire le test'
        }
      }
    },
    videoTests: {
      bess: {
        name: 'Test BESS',
        description: 'Evaluation de votre d\'équilibre',
        instructions: {
          title: 'Instructions pour le test d\'équilibre (BESS)',
          description1: 'Ce test permet de mesurer votre équilibre et votre stabilité posturale.',
          description2: 'Vous serez invité·e à tenir en équilibre sur un pied, les mains sur les hanches et les yeux fermés. Le système analysera vos mouvements corporels à l\'aide de la caméra frontale.',
          rules: {
            eyesClosed: 'Gardez les yeux fermés pendant toute la durée du test.',
            handsOnHips: 'Maintenez vos mains sur les hanches.',
            holdPosition: 'Restez immobile et tenez la position pendant 20 secondes sans perdre l\'équilibre.'
          },
          errors: 'Une erreur est comptabilisée chaque fois que vous ouvrez les yeux, déplacez vos pieds, retirez vos mains des hanches, ou que vous perdez l\'équilibre.',
          automatic: 'Le test est automatique. Il démarre dès que vous êtes correctement positionné·e.',
          continueButton: 'Continuer'
        },
        steps: {
          title: 'Comment réaliser le test :',
          calibration: {
            title: '1. Calibration',
            description: 'Placez-vous debout face à la caméra pour calibrer le système'
          },
          position: {
            title: '2. Position à tenir',
            description: 'Tenez-vous sur un pied, mains sur les hanches, yeux fermés'
          },
          startButton: 'Commencer le test'
        },
        setup: {
          phoneStable: 'Posez votre téléphone sur une surface stable',
          videoLoading: 'Vidéo en cours de chargement…'
        },
        calibration: {
          fullBody: 'Placez tout votre corps dans le cadre',
          waiting: 'La calibration va commencer, ne bougez plus',
          inProgress: 'Calibration en cours, ne bougez pas',
          oneFoot: 'Mettez-vous sur votre pied non-dominant',
          handsOnHips: 'Mettez les mains sur les hanches',
          ready: 'Le test va commencer, ne bougez plus'
        },
        testing: {
          message: 'Test en cours, fermez les yeux'
        },
        results: {
          title: 'Résultats du test d\'équilibre',
          oneFootErrors: 'Erreurs sur 1 pied',
          retryButton: 'Refaire le test'
        }
      },
      eyeTracking: {
        name: 'Eye Tracking',
        description: 'Suivi des mouvements oculaires',
        instructions: {
          title: 'Instructions pour le test Eye Tracking',
          description1: 'Ce test permet de mesurer vos mouvements oculaires, votre attention visuelle et votre capacité à suivre un stimulus.',
          description2: 'Un point blanc se déplacera à l’écran selon une trajectoire précise.',
          rule1: 'Gardez la tête immobile face à l’écran.',
          rule2: 'Suivez le point uniquement avec vos yeux, sans bouger la tête.',
          rule3: 'Concentrez-vous et essayez de rester attentif pendant toute la durée de l’exercice.',
          description3: 'Ce test ne nécessite aucune interaction. Il se déroule automatiquement pendant quelques secondes.',
          startButton: 'Commencer le test'
        },
        setup: {
          videoLoading: 'Vidéo en cours de chargement…',
          alignFace: 'Alignez votre visage avec les contours'
        },
        results: {
          title: 'Résultats du eye tracking',
          concussionProbability: 'Probabilité de commotion',
          retryButton: 'Refaire le test'
        }
      }
    },
    breatheExercise: {
      name: 'Exercices de respiration',
      description: 'Respiration et relaxation',
      instructions: {
        title: 'Choisissez un protocole de Respiration',
        level: 'Niveau :',
        details: {
          recommendedContext: 'Contexte recommandé :',
          contraindications: 'Contre-indications :',
          remarks: 'Remarques :',
          breathingPhases: 'Phases de respiration :',
          inhale: 'Inspiration',
          holdInhale: 'Rétention (pleins)',
          exhale: 'Expiration',
          holdExhale: 'Rétention (vides)',
          seconds: 'secondes',
          recommendedCycles: 'Cycles conseillés :',
          cyclesPerMinute: '{n} respirations par minute pendant {m} minutes',
          selectButton: 'Sélectionner ce protocole',
          changeButton: 'Changer d\'exercice'
        }
      },
      running: {
        prepare: 'Préparez-vous',
        relax: 'Détendez-vous, l\'exercice va commencer...',
        followRythm: 'Suivez le rythme indiqué à l\'écran et les changements de couleur pour vous guider.',
        cycle: 'Cycle :',
        timeRemaining: 'Temps restant :',
        inhale: 'Inspirez',
        hold: 'Retenez',
        exhale: 'Expirez',
        finishButton: 'Terminer l\'exercice'
      },
      results: {
        title: 'Exercice de respiration terminé',
        completionMessage: 'Vous avez complété {completed} cycles de respiration sur une durée de {duration}.',
        mainEffect: 'Effet principal :',
        recommendedContext: 'Contexte recommandé :',
        feelings: 'Comment vous sentez-vous ? Prenez un moment pour observer les effets de cet exercice sur votre corps et votre esprit.',
        backButton: 'Revenir aux exercices'
      },
      protocols: {
        coherence: {
          name: 'Cohérence cardiaque',
          desc: 'Apaisante',
          effect: 'Apaisement général, régulation de la variabilité cardiaque, réduction du stress',
          context: 'relaxation, récupération, préparation mentale, usage quotidien',
          remarks: 'très utilisé dans les milieux médicaux, sportifs, et de la méditation',
          level: 'Débutant',
          contraindications: 'aucune'
        },
        pranayama: {
          name: 'Pranayama doux',
          desc: 'Inspiré du yoga traditionnel',
          effect: 'Équilibrage émotionnel, recentrage, ralentissement du mental',
          context: 'transitions, pratiques méditatives, récupération mentale',
          remarks: 'transition douce vers des pratiques plus complexes',
          level: 'Tous niveaux',
          contraindications: 'éviter si sensation d\'oppression ou de vertige'
        },
        respiration12: {
          name: 'Respiration 1:2',
          desc: 'Calmante prolongée',
          effect: 'Activation du parasympathique, ralentissement cardiaque et respiratoire',
          context: 'retour au calme, récupération post-effort, stress aigu',
          remarks: 'à proposer comme "respiration anti-panik" dans l\'app',
          level: 'Débutant',
          contraindications: 'aucune'
        },
        respiration21: {
          name: 'Respiration 2:1',
          desc: 'Activation légère',
          effect: 'Légère activation cognitive et mentale, montée en vigilance',
          context: 'pré-match, avant prise de parole, échauffement mental',
          remarks: 'à ne pas confondre avec des techniques d\'hyperventilation',
          level: 'Débutant',
          contraindications: 'éviter chez les hypertendus non suivis'
        },
        box: {
          name: 'Box Breathing',
          desc: 'Respiration carrée',
          effect: 'Récupération mentale, recentrage, gestion du stress',
          context: 'gestion émotionnelle, entretiens stressants, sport de haut niveau',
          remarks: 'utilisée par les forces spéciales et en pleine conscience',
          level: 'Intermédiaire',
          contraindications: 'éviter en cas de vertiges ou de troubles respiratoires aigus'
        },
        fourSevenEight: {
          name: '4-7-8',
          desc: 'Dr Andrew Weil',
          effect: 'Induction du sommeil, relâchement profond',
          context: 'coucher, anxiété élevée, détente profonde',
          remarks: 'à faire assis ou allongé, jamais en situation de conduite',
          level: 'Avancé',
          contraindications: 'ne pas proposer à des personnes souffrant d\'asthme, d\'hyperventilation ou d\'hypotension sévère'
        }
      }
    }
  },
  s: 's',
  ms: 'ms',
  forms: {
    title: 'Mes questionnaires',
    questionnaire: 'Questionnaire',
    available: 'Disponible',
    concussionHistory: {
      name: 'Historique des Commotions',
      description: 'Vos antécédents de commotions cérébrales'
    },
    concussionSymptoms: {
      name: 'Auto-évaluation des Symptômes',
      description: 'Questionnaire quotidien sur vos symptômes'
    },
    progressiveReturnFollowUp: {
      name: 'Suivi de Reprise Progressive',
      description: 'Évaluation après chaque palier'
    }
  }
}
